import type { FieldProp } from 'react-typed-form';

import * as React from 'react';
import { css, html } from 'react-strict-dom';

import { ErrorList } from '../../components';

export type Props = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: FieldProp<any>;
  required?: boolean;
  autoFocus?: boolean;
  // Passthrough
  placeholder?: string;
  onChange?: (arg1: React.ChangeEvent<HTMLInputElement>) => unknown;
  type?: React.ComponentProps<typeof html.input>['type'];
}>;

export default function LoginField({
  field,
  autoFocus,
  onChange,
  ...rest
}: Props) {
  const inputEl = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    if (autoFocus) inputEl.current?.focus();
  }, []);

  return (
    <html.div>
      <html.input
        ref={inputEl}
        style={styles.input}
        value={field.value || ''}
        onChange={
          onChange ||
          ((e: React.ChangeEvent<HTMLInputElement>) =>
            field.handleValueChange(e.target.value))
        }
        disabled={field.isLoading}
        placeholder={field.label}
        {...rest}
      />
      <ErrorList errors={field.lastErrorList} />
    </html.div>
  );
}

const styles = css.create({
  input: {
    boxSizing: 'border-box',
    display: 'block',
    width: '100%',
    height: 44,
    fontSize: 14,
    fontFamily: 'Inter, sans-serif',
    lineHeight: 1.5,
    paddingBlock: 6,
    paddingInline: 12,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#cbcbd2',
    borderRadius: 4,
    transition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s',
    marginBottom: 20,
    ':focus': {
      boxShadow:
        'inset 0 1px 2px rgba(203, 203, 210, 0.2), 0 0 4px rgba(121, 88, 159, 0.3)',
      borderColor: '#79589f',
    },
  },
});
